import React from 'react';
import { motion } from 'framer-motion';

export default function About() {
  return (
    <section id="about" className="pt-8 pb-24 px-6 md:px-8 relative" style={{ backgroundColor: 'var(--bg)' }}>
      <div className="container-premium flex flex-col md:flex-row items-center gap-12">
        <motion.div
          className="md:w-1/2"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
        >
          <div className="eyebrow mb-4">About Us</div>
          <h2 className="t-h1 font-display mb-6" style={{ color: 'var(--text-primary)' }}>About Ufeus</h2>
          <p className="t-body" style={{ color: 'var(--text-secondary)' }}>
            With over two decades of expertise in system architecture and enterprise software development,
            Ufeus Consultancy Services was built to bridge the gap between AI-driven innovation and
            real-world software design — bringing the discipline of enterprise engineering to modern,
            AI-assisted product delivery.
          </p>
        </motion.div>
        <motion.div
          className="md:w-1/2 flex justify-center items-center"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, delay: 0.15 }}
        >
          <div className="card w-full max-w-sm aspect-square flex flex-col items-center justify-center gap-4 p-8 relative overflow-hidden">
            <div className="ai-orb w-64 h-64" style={{ opacity: 0.2 }} />
            <span className="stat-num text-5xl relative z-10" style={{ color: 'var(--accent)' }}>22+</span>
            <span className="t-label relative z-10" style={{ color: 'var(--text-muted)' }}>Years of Combined Leadership Experience</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
